import {
  FAVORITE_SCRIPT,
  FAVORITED_SCRIPT,
  GET_SCRIPT,
  FAVORITED_SCRIPT_API_ERROR,
  FAVORITED_SCRIPT_RESET_ERROR,
} from "./actionTypes";



export const favoriteScript = (scriptId, remove) => {
  return {
    type: FAVORITE_SCRIPT,
    payload: { scriptId, remove },
  };
};

export const getScript = () => {
  return {
    type: GET_SCRIPT,
    payload: { },
  };
};
export const favoritedScript = (data) => {
  return {
    type: FAVORITED_SCRIPT,
    payload: data,
  };
};

export const favoritedScriptApiError = (error) => {
  return {
    type: FAVORITED_SCRIPT_API_ERROR,
    payload: error,
  };
};

export const favoritedScriptResetError = () => {
  return {
    type: FAVORITED_SCRIPT_RESET_ERROR,
    payload: {},
  };
};

